<script>
  import EditView from '../base/EditView.vue'
  import FormInput from '../form/form-input.vue'
  import FormTextarea from '../form/form-textarea.vue'
  import FormLookup from '../form/form-lookup.vue'
  import FormDatepicker from '../form/form-datepicker.vue'
  import FormTaxrate from '../form/form-taxrate'
  import FormTimePicker from "../form/form-time-picker";

  export default {
    components: {
      FormTimePicker,
      EditView,
      FormInput,
      FormTextarea,
      FormLookup,
      FormDatepicker,
      FormTaxrate
    },
    data () {
      return {
        taxRateOptions: [
          {value: 0, text: '0%'},
          {value: 5, text: '5%'},
          {value: 7, text: '7%'},
          {value: 16, text: '16%'},
          {value: 19, text: '19%'},
        ],
        timeDiff: 0.0
      }
    },
    computed: {
      hasInvalidDuration () {
        return !this.timeDiff || (this.timeDiff <= 0.0)
      },
      timeStart () {
        return this.$store.getters['workinghour/update/item'].timeBegin || ''
      },
      timeStop () {
        return this.$store.getters['workinghour/update/item'].timeEnd || ''
      }
    },
    watch: {
      timeStart (newVal, oldVal) {
        if (oldVal !== newVal) {
          this.recalcTimediff()
        }
      },
      timeStop (newVal, oldVal) {
        if (oldVal !== newVal) {
          this.recalcTimediff()
        }
      }
    },
    methods: {
      recalcTimediff () {
        const end = this.timeStop.split(':')
        const start = this.timeStart.split(':')

        let duration = (((parseInt(end[0]) * 60 + parseInt(end[1])) - (parseInt(start[0]) * 60 + parseInt(start[1]))) / 60) * 100
        if (isNaN(duration)) {
          return 0
        }
        duration = Math.ceil(duration) / 100

        // FIXME: Apply rounding to .5h, .25h, ...

        this.timeDiff = duration
      },
      setDuration () {
        this.$store.dispatch('workinghour/update/updateItem', { amount: Math.ceil(this.timeDiff) })
      },
      setDotFiveDuration () {
        this.$store.dispatch('workinghour/update/updateItem', { amount: Math.ceil(this.timeDiff / 0.5) * 0.5 })
      },
      setDotTwoFiveDuration () {
        this.$store.dispatch('workinghour/update/updateItem', { amount: Math.ceil(this.timeDiff / 0.25) * 0.25 })
      }
    }
  }
</script>
<template>
  <edit-view store="workinghour" list-route="WorkingHourList" v-slot:default="slotProps">
    <form-lookup :store="slotProps.store" prop-name="customer" class="col-4">
      <template v-slot:selected-item="slotProps">
        {{slotProps.item.addr1}}
        {{slotProps.item.addr2}}
      </template>
      <template v-slot:item="slotProps">
        {{slotProps.item.addr1}}<br/>
        {{slotProps.item.addr2}}
      </template>
    </form-lookup>
    <form-lookup :store="slotProps.store" prop-name="invoice" class="col-4">
      <template v-slot:selected-item="slotProps">
        {{slotProps.item.invoiceNr}}
        {{slotProps.item.customerAddr1}}
        {{slotProps.item.customerAddr2}}
      </template>
      <template v-slot:item="slotProps">
        {{slotProps.item.invoiceNr}}
        {{slotProps.item.customerAddr1}}<br/>
        {{slotProps.item.customerAddr2}}
      </template>
    </form-lookup>
    <form-lookup :store="slotProps.store" prop-name="project" class="col-4">
      <template v-slot:selected-item="slotProps">
        {{slotProps.item.projectnr}}
        {{slotProps.item.name}}
      </template>
      <template v-slot:item="slotProps">
        {{slotProps.item.projectnr}}
        {{slotProps.item.name}}
      </template>
    </form-lookup>
    <form-datepicker :store="slotProps.store" prop-name="start" format="YYYY-MM-DD" class="col-2"></form-datepicker>
    <form-time-picker :store="slotProps.store" prop-name="timeBegin" class="col-2"></form-time-picker>
    <form-time-picker :store="slotProps.store" prop-name="timeEnd" class="col-2"></form-time-picker>
    <form-input :store="slotProps.store" prop-name="amount" type="number" step="0.01" class="col-3">
      <template #prepend>
        <b-input-group-prepend>
          <b-button
            type="button"
            :disabled="true"
          >
            {{timeDiff}}h&nbsp;=&gt;
          </b-button>
          <b-button
            type="button"
            title="Round to half hours"
            variant="success"
            @click="setDuration"
            class="form-control"
            :disabled="hasInvalidDuration"
          >
            1h
          </b-button>
          <b-button
            type="button"
            title="Round to half hours"
            variant="success"
            @click="setDotFiveDuration"
            class="form-control"
            :disabled="hasInvalidDuration"
          >
            1/2h
          </b-button>
          <b-button
            type="button"
            title="round to quarter hours"
            variant="success"
            @click="setDotTwoFiveDuration"
            class="form-control"
            :disabled="hasInvalidDuration"
          >
            1/4h
          </b-button>
        </b-input-group-prepend>
      </template>
    </form-input>
    <form-input :store="slotProps.store" prop-name="singleprice" type="number" class="col-2"></form-input>
    <form-taxrate :store="slotProps.store" prop-name="taxrate" class="col-2"></form-taxrate>
    <form-textarea :store="slotProps.store" prop-name="description" class="col-12"></form-textarea>
  </edit-view>
</template>
